import {fromJson, URL_BASE_AUTH} from "../utils/helper.js";


class WordParagraph {


    constructor() {

        this.id = null;
        this.content = null;

    }


    static fromJson(object) {
        return fromJson((new WordParagraph()), object);
    }

}

export default WordParagraph;
